import envConfig from 'config.env';

// Configuration is fetched from AEM async on load
// This service is used to manage the network request
// and caching the object in memory
export default class ConfigurationService {
  /* @ngInject */
  constructor($http) {
    this.$http = $http;
    this.bootstrap = this.bootstrapConfiguration();
  }

  getConfiguration() {
    return this.config || {};
  }

  bootstrapConfiguration() {
    // If config has already been fetched return this instead
    return this.config ?
      Promise.resolve(this.config) :
      this.fetchConfiguration();
  }

  fetchConfiguration() {
    let configPromise;

    // If configUrl is supplied make a http request to fetch it
    if (envConfig.configUrl) {
      configPromise = this
        .$http({
          method: 'GET',
          url: envConfig.configUrl,
          responseType: 'json'
        })
        .then(result => result.data);
    } else {
      // Else we assume content is supplied in configuration
      configPromise = Promise.resolve(envConfig.content);
    }

    return configPromise
      .then((config) => {
        // Store config in the service for future use
        this.config = config;
        return config;
      });
  }

}




// WEBPACK FOOTER //
// ./src/services/configuration.service.js